@import "../../styles/colors";

.root {
  position: relative;
  margin-top: 25vh;
  height: 75vh;
}

.shapeCluster01 {
  position: absolute;
  top: 0%;
  left: 40%;
  width: 8em;

  .hemiLeft {
    position: absolute;
    right: 0;
    top: 0;
    width: 50%;
  }

  .hemiRight {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 50%;
  }
}

.shapeCluster02 {
  position: absolute;
  left: 5%;
  top: 25%;
  width: 18em;
  height: 30em;

  .triangleBig {
    position: absolute;
    left: 0;
    top: 20%;
    width: 60%;
  }

  .triangleSmall {
    position: absolute;
    right: 0;
    top: 0;
    width: 60%;
  }

  .hemi {
    position: absolute;
    right: 0;
    bottom: 30%;
    width: 40%;
  }
}

.shapeCluster03 {
  position: absolute;
  top: 90%;
  left: 45%;
  width: 17em;
  height: 10em;

  .triangleTop {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
  .triangleBottom {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
  .triangleBig {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 80%;
  }
}

.shapeCluster04 {
  position: absolute;
  top: 25%;
  right: 5%;
  width: 16em;

  .triangle {
    position: absolute;
    width: 66.666%;
    top: 0;
    left: 0;
  }
  .square {
    position: absolute;
    width: 66.666%;
    right: 0;
    top: 0;
  }
  .hemiRight {
    position: absolute;
    width: 33.333%;
    right: 0;
    top: 0;
  }
}
